import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withRouter } from "react-router-dom";
import { Button, withStyles, Box, TextField as MuiTextField } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import FormDialog from "../../../shared/components/FormDialog";
import ButtonCircularProgress from "../../../shared/components/ButtonCircularProgress";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AuthActions from "../../../redux/actions/auth";
import { TextField, Autocomplete, Checkboxes, makeValidate, makeRequired, showErrorOnBlur } from 'mui-rff';
import styled from 'styled-components';
import sleep from './../../../shared/functions/sleep';
import * as yup from 'yup';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import AddIcon from '@material-ui/icons/Add';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import api from './../../../shared/functions/api/';
import countries from './../../../shared/constants/countries';


export const Styles = styled.div` 

.MuiFormControl-root {

    input {
        font-family: Lato;
        font-size: 15px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: left;
        color: #484f57;

        &:disabled{
          color: black;
          opacity: 0.4;
        }
    }
}

.flexWrapFields {
    display: flex;
    gap: 32px;

    & > div {
        flex: 1;

        &.flexColumn{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
    }
}

h2{
  font-family: MinionPro-Disp;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #b08f6e;
  text-transform: uppercase;
  margin: 0;
}
`;

const schema = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  companyName: yup.string().required(),
  addressLine1: yup.string().required(),
  city: yup.string().required(),
  postcode: yup.string().required(),
  phone: yup.string().required(),
  country: yup.string().required().default(''),
  acceptTermsAndConditions: yup.boolean().oneOf([true], 'Must Accept Terms and Conditions').required('Must Accept Terms and Conditions'),
});
const validate = makeValidate(schema);
const required = makeRequired(schema);

const styles = (theme) => ({});

const TextButton = styled(Button)`
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.19;
  letter-spacing: normal;
  text-align: left;
  color: #6d7279;
  margin-left: -8px;
  text-transform: none;
  margin-top: 25px;
`;

const TermsWrap = styled.div`
  margin-top: auto;
  text-align: right;
  width: 100%;
  .MuiFormControl-root{
    display: block;
    label{
      justify-content: flex-end;
      margin: 0;
    }
  }
`;

class RegisterDialog extends PureComponent {

  state = {
    status: false,
  };

  componentDidMount() {
    this.setState({ status: this.props.status })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status !== this.props.status) {
      this.setState({ status: this.props.status })
    }
  }

  setStatus(status) {
    this.setState({ status })
  }

  onFormSubmit = async (data) => {
    const { history, onComplete } = this.props;
    this.setStatus(null);

    if (data.tradeReferences.filter(t => t).length === 0) {
      return this.setStatus({ general: 'Please enter at least 1 Trade Reference' })
    }

    await sleep(1000);

    try {
      const res = await api.post('/register', data);
      onComplete(res.data);
    } catch (err) {
      Array.isArray(err.response.data.errors.msg)
        ? this.setStatus({ [err.response.data.errors.msg[0].param]: err.response.data.errors.msg[0].msg })
        : this.setStatus({ general: err.response.data.errors.msg });
    }
  };

  render() {
    const { classes, onClose, initialValues, description, onBack,

    } = this.props;
    const { status } = this.state;

    // must be done like this because when using the spread operator to make a new object, the reference of the object will be different
    // and react final form will detect an object change at every re-render resulting on all fields to be reset.
    // https://stackoverflow.com/questions/54635276/react-final-form-set-initialvalues-from-props-form-state-resets-on-props-chang
    initialValues.tradeReferences = ['', ''];

    return (
      <Fragment>
        <FormDialog
          open
          status={status && status.general}
          onClose={onClose}
          validate={validate}
          initialValues={initialValues}
          onFormSubmit={(data) => this.onFormSubmit(data)}
          headline="Welcome"
          description={description || <span>Please enter the following details to request access to the full features of our website.</span>}
          columnsLayout={true}
          maxWidth={"lg"}
          mutators={{
            ...arrayMutators,
          }}
          content={({ submitting, values, form: { mutators: { push, pop } } }) =>
            <Styles>
              {<React.Fragment>
                <div className="flexWrapFields">
                  <div>
                    <h2>Login Information</h2>

                    <TextField margin="dense" label="Title" name="title" />
                    <TextField margin="dense" label="First Name" name="firstName" required={required.firstName} />
                    <TextField margin="dense" label="Last Name" name="lastName" required={required.lastName} />
                    <TextField margin="dense" label="Company Name" name="companyName" required={required.companyName} />

                    <TextField
                      margin="dense"
                      label="Company Website"
                      name="companyWebsite"
                      // server side errors
                      helperText={status && status.companyWebsite}
                      // inject only when needed, else it messes internal error prop
                      {...{ [status && status.companyWebsite && 'error']: status && status.companyWebsite ? true : false }}
                    />

                    <TextField margin="dense" label="Telephone" name="phone" required={required.phone} />
                    <TextField margin="dense" label="Mobile Telephone" name="mobileTelephone" />

                    <TextField margin="dense" label="Address Line 1" name="addressLine1" required={required.addressLine1} />
                    <TextField margin="dense" label="Address Line 2" name="addressLine2" />

                    <div className="flexWrapFields">
                      <TextField margin="dense" label="Town / City" name="city" required={required.city} />
                      <TextField margin="dense" label="County / State" name="county" />
                    </div>

                    <div className="flexWrapFields">
                      <TextField margin="dense" label="Post Code / Zip" name="postcode" required={required.postcode} />
                      <Autocomplete
                        name="country"
                        label="Country"
                        options={countries.map(country => ({ label: country, value: country }))}
                        getOptionValue={x => x.value}
                        getOptionLabel={x => x.label}
                        textFieldProps={{
                          margin: "dense",
                        }}
                        autoComplete="off"
                        renderInput={(params) => (
                          <MuiTextField {...params} label={<React.Fragment>Cou<span style={{ display: 'none' }}>stop-autofill-haha</span>ntry</React.Fragment>} margin="dense" />
                        )}
                        required={required.country}
                      />
                    </div>
                  </div>

                  <div className="flexColumn">
                    <h2>Company Information</h2>

                    <FieldArray name="tradeReferences">
                      {({ fields }) => <div>
                        {fields.map((name, index) => {
                          return (<TextField margin="dense" label={`Trade Reference ${index + 1}`} name={name} required={index === 0} />)
                        })}
                        {fields.length < 5 &&
                          <TextButton startIcon={<AddIcon />} onClick={() => push('tradeReferences', '')}>Add Trade Reference</TextButton>
                        }
                      </div>}

                    </FieldArray>

                    <br/>
                    <div style={{height: 50}}>
                      <Checkboxes
                        name="requestApiAccess"
                        data={[
                          { label: 'Request API Access', value: true },
                        ]}
                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                      />
                    </div>
                    
                    {values && values.requestApiAccess && <TextField InputProps={{style: {flex: 0}}} placeholder="Start typing your message..." name="requestApiAccessMessage" fullWidth multiline rows={10} />}

                    <TermsWrap>
                      <Checkboxes
                        name="acceptTermsAndConditions"
                        data={[{ label: <span>Accept <a style={{ color: '#b08f6e' }} onClick={e => e.stopPropagation()} href="/terms-and-conditions" target="_blank">Terms &amp; Conditions</a></span>, value: true }]}
                        icon={<CheckCircleIcon style={{ opacity: 0.2 }} />} checkedIcon={<CheckCircleIcon style={{ color: '#b08f6e' }} />}
                        required={required.acceptTermsAndConditions}
                      />
                    </TermsWrap>
                  </div>
                </div>
              </React.Fragment>}

            </Styles>
          }
          actions={({ submitting, pristine }) =>
            <Fragment>
              <Button
                type="button"
                variant="contained"
                color="default"
                disabled={submitting}
                onClick={() => onBack ? onBack({ initialValues }) : onClose()}
              >
                Back
              </Button>

              <Button
                type="submit"
                variant="contained"
                color="secondary"
                disabled={submitting || pristine}
              >
                Continue
                {submitting && <ButtonCircularProgress />}
              </Button>
            </Fragment>
          }
          actionsStyle={{ justifyContent: 'flex-end', gap: 100, marginTop: 50 }}
        />
      </Fragment>
    );
  }
}

export default connect(null, (dispatch) =>
  bindActionCreators({ ...AuthActions }, dispatch)
)(withRouter(withStyles(styles)(RegisterDialog)));
